import { forwardRef, useCallback, useEffect, useState } from "react";
import { Input } from 'reactstrap';
import './Switch.css'
import Fetch from '../../../../../util/core/Fetch';

const MultiCheckBox = forwardRef((props, ref) => {
    let className = '';

    const [checkBoxOptions, setCheckBoxOptions] = useState(props.value || []);

    const loadOptions = async () => {
        if (props.options && props.options.length > 0) {

            const rows = props.options.map(item => {
                let value = false;

                if(props.value){
                    props.value.map(item2 => {
                        if(item.id = item2.id){
                            value = item2.value
                        }
                    })
                }

                return {
                    id: item.value,
                    value: value,
                    label: item.label
                }
            });

            const tempOptions = rows.map(item => {
                let value = false;
    
                if(props.value){
                    props.value.map(item2 => {
                        if(item.id === item2.id){
                            value = item2.value
                        }
                    })
                }
    
                return {
                    id: item.id,
                    value: value,
                    label: item.label
                }
            })     
    
            setCheckBoxOptions(tempOptions);

            return;
        }

        if (props.optionsEndpoint && props.optionsEndpoint.endpoint && !props.options.length) {
            let url = props.optionsEndpoint.endpoint;
            let keyLabel = props.optionsEndpoint.label;
            let keyValue = props.optionsEndpoint.value;
            const params = props.optionsEndpoint.params ? props.optionsEndpoint.params : {};            

            const rows = await Fetch.post(url, params);

            const tempOptions = rows.map(item => {
                    let value = false;
        
                    if(props.value.length > 0){
                        props.value.map(item2 => {
                            if(item.id === item2.id){
                                value = item2.value
                            } 
                        })
                    }   
        
                    return {
                        id: item[keyValue],
                        value: value,
                        label: item[keyLabel]
                    }
            });
    
            setCheckBoxOptions(tempOptions);

            return;
        }

    }

    const handleSelect = (id) => {
        const optionsChecked = checkBoxOptions.map(option => {
            if (option.id === id) {
                option.value = !option.value;
            }

            return option
        })

        setCheckBoxOptions(optionsChecked);

        props.onChange({
            target: {
                name: props.name,
                value: optionsChecked
            }
        });
    };

    const handleSelectAll = (event) => {
        const { checked } = event.target;
        const allCheckboxesChecked = checkBoxOptions.map(option => ({ ...option, value: checked }));

        setCheckBoxOptions(allCheckboxesChecked);

        props.onChange({
            target: {
                name: props.name,
                value: allCheckboxesChecked
            }
        }) 
    };

    if (props.error) {
        className = "is-invalid";
    }

    useEffect(() => { loadOptions() }, []);

    return (
        <div style={{ gap: props.switch ? '12px' : '2px' }} ref={ref} className="d-flex flex-column align-items-start">
            {props.error && (
                <div
                    className="error invalid-feedback"
                    style={{ marginBottom:'20px',fontSize:'1em' }}>
                    {props.error}
                </div>
            )}
            
            {!!props.showSelectAll && (
                <div className="d-flex align-items-center">
                    <label htmlFor={'id_multi_checkbox_select_all' + props.name}>
                        {props.switch && 'Marcar Todos'}
                    </label>

                    <label className={props.switch ? "switch m-0 ml-2" : ""}>
                        <Input
                            id={'id_multi_checkbox_select_all' + props.name}
                            ref={ref}
                            type="checkbox"
                            className={className}
                            name={props.name}
                            disabled={props.disabled}
                            onChange={event => handleSelectAll(event)}
                            autoFocus={props.autoFocus ? true : false}
                            style={{ marginTop: '.4rem' }}
                            checked={checkBoxOptions.every(option => option.value)}
                        />

                        {props.switch && <span className="slider round"></span>}
                        {!props.switch && <span>Marcar todos</span>}
                        {props.required && <span className="required"> *</span>}
                    </label>
                </div>
                )
            }

            {checkBoxOptions.map(option => (
                <div key={option.id} className={props.label ? "d-flex align-items-center" : ""}>
                    <label htmlFor={'id_' + option.label}>
                        {props.switch && option.label}
                    </label>
                    <label className={props.switch ? "switch m-0 ml-2" : ""}>
                        <Input
                            id={'id_' + option.label}
                            onChange={() => handleSelect(option.id)}
                            className={className}
                            type="checkbox"
                            name={props.name}
                            checked={option.value}
                            ref={ref} 
                            style={{ marginTop: '.4rem' }}
                            disabled={props.disabled}
                            autoFocus={props.autoFocus ? true : false}
                        />
                        {props.switch && <span className="slider round"></span>}
                        {!props.switch && <span >{option.label}</span>}
                        {props.required && <span className="required"> *</span>}
                    </label>
                </div>
            ))}

        </div>
    );
})
export default MultiCheckBox;